import { render, staticRenderFns } from "./ListadoProductosComponent.vue?vue&type=template&id=053aa648&scoped=true"
import script from "./ListadoProductosComponent.vue?vue&type=script&lang=js"
export * from "./ListadoProductosComponent.vue?vue&type=script&lang=js"
import style0 from "./ListadoProductosComponent.vue?vue&type=style&index=0&id=053aa648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053aa648",
  null
  
)

export default component.exports